import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.svg';

const Navbar = () => {
  return (
    <nav style={styles.nav}>
      <div style={styles.brand}>
        <Link to="/" style={styles.brandLink}>
          <div style={styles.brandInner}>
            <img src={logo} alt="Flying Jib Capital" style={styles.logo} />
            <div style={styles.divider} />
            <span style={styles.brandName}>FLYING JIB CAPITAL</span>
          </div>
        </Link>
      </div>

      <div style={styles.links}>
        <Link to="/" style={styles.link}>Home</Link>
        <Link to="/about" style={styles.link}>About</Link>
        <Link to="/founding" style={styles.link}>Founding</Link>
        <Link to="/portfolio" style={styles.link}>Portfolio</Link>
        <Link to="/dashboard" style={styles.link}>Dashboard</Link>
      </div>
    </nav>
  );
};

const styles = {
  nav: {
    backgroundColor: '#0a1628',
    padding: '0 40px',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #1e3a5f',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
  },
  brandLink: {
    textDecoration: 'none',
  },
  brandInner: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
  },
  logo: {
    height: '36px',
    width: 'auto',
  },
  divider: {
    width: '1px',
    height: '28px',
    backgroundColor: 'rgba(255,255,255,0.15)',
  },
  brandName: {
    color: '#ffffff',
    fontSize: '15px',
    fontWeight: '400',
    letterSpacing: '3px',
    fontFamily: 'Georgia, serif',
  },
  links: {
    display: 'flex',
    gap: '32px',
  },
  link: {
    color: '#a8b8cc',
    textDecoration: 'none',
    fontSize: '13px',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    fontFamily: 'Georgia, serif',
    transition: 'color 0.2s',
  },
};

export default Navbar;